import axios from 'axios'
import qs from 'qs'
import router from '../router/index'
import Vue from 'vue'
import iView from 'iview'
import { redirectUtil } from '@/utils/redirect';
Vue.use(iView)

// axios 配置  timeout单位为毫秒
var timeOut = 1000 * 60 * 10
axios.defaults.timeout = timeOut
axios.defaults.baseURL = process.env.COREAPI_HOST
axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
}

function parseArraybufferData(data) {
    if (!data) return null

    try {
        const decoder = new TextDecoder('utf-8')
        const text = decoder.decode(data) 
        // 第一次解析：从字符串解析出实际的 JSON 字符串
        const jsonString = JSON.parse(text)  // jsonString: {"Message":"FileNotExistError"}

        // 第二次解析：解析实际的 JSON
        const parsed = JSON.parse(jsonString)  // parsed: {Message: "FileNotExistError"}

        // 支持多种可能的字段名
        return parsed.Message;

    } catch (e) {
        console.error('解析arraybuffer错误:', e)
        return null
    }
}


let num = 0

// http request 拦截器
axios.interceptors.request.use(
    config => {
        num++;
        if (config.url.startsWith(process.env.COREAPI_HOST)) {
            config.url = config.url.substring(process.env.COREAPI_HOST.length);
            config.baseURL = process.env.COREAPI_HOST;
        }
        config.paramsSerializer = params => { return qs.stringify(params, { indices: false }) };
        if (sessionStorage.demoSpinIconLoad === 'true') {
            Vue.prototype.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'load-a',
                                size: 36
                            }
                        })
                    ])
                }
            })
        }
        sessionStorage.demoSpinIconLoad = 'true'
        if (localStorage.token) {
            config.headers.Authorization = 'MerckAuthentication ' + localStorage.token
            config.headers['Accept-Language'] = localStorage.getItem('currentLanguage') === null ? 'zh-CN' : localStorage.getItem('currentLanguage') === 'mergeZH' ? 'zh-CN' : 'en-US'
            config.headers['route'] = sessionStorage.route
        }
        config.data = JSON.stringify(config.data)
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

// http response 拦截器
axios.interceptors.response.use(
    response => {
        num--;
        // 如果响应头中有新token，更新本地存储           
        const newToken = response.headers['x-new-token'];
        if (newToken) {
            localStorage.setItem('token', newToken);
        }
        if (num <= 0) {
            Vue.prototype.$Spin.hide()
        }
        if (response.status === 204) {

        } else {
            return response
        }
    },
    error => {
        num--;
        if (num <= 0) {
            Vue.prototype.$Spin.hide()
        }
        let duration = 5;
        let errMsg = '未知错误!';
        if (error.response) {
            switch (error.response.status) {
                case 500:
                    if (error.response.data) {
                        if (error.response.config.responseType === 'arraybuffer') {
                            errMsg = parseArraybufferData(error.response.data);
                        } else {

                            errMsg = JSON.parse(error.response.data).Message;
                        }
                    } else {
                        errMsg = '请求服务器被拒绝，请清空浏览器缓存后重试'
                    }
                    break
                case 400:
                    if (error.response.data) {
                        if (error.response.config.responseType === 'arraybuffer') {
                            errMsg = parseArraybufferData(error.response.data);
                        } else {
                            errMsg = JSON.parse(error.response.data).Message;

                        }
                    } else {
                        errMsg = '当前操作引发未知错误，请联系管理员';
                    }
                    break
                case 401:
                    //简化处理, 只要是401问题, 直接跳转到登录页
                    errMsg = '用户身份信息已过期。';//不在提示
                    localStorage.clear()
                    redirectUtil.saveRedirectUrl();
                    router.push({ name: 'loginJump', params: { code: 'system.userIdentityExpired' } })
                    break
                case 403:
                    errMsg = '没有权限访问'
                    break
                case 404:
                    errMsg = '找不到访问的资源'
                    break
                case 405:
                    errMsg = '访问失败，请联系管理员'
                    break
                default:
                    break
            }

        }
        if (errMsg) {
            if (errMsg.length > 20) {
                duration = 10;
            }
            Vue.prototype.$Message.error({
                content: errMsg,
                duration: duration
            })
        }
        return Promise.reject(error)
    }
)
export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js